import fs from "fs";
import path from "path";

export default async function getDataSchema() {
    // TODO: get from keys in production
    let schema = `generator client {
    provider        = "prisma-client-js"
    previewFeatures = ["nativeTypes"]
}
datasource db {
  provider = "mysql"
  url      = "mysql://${[process.env.DB_USER, process.env.DB_PASSWORD].map(encodeURIComponent).join(':')}@${process.env.DB_HOST}/${process.env.DB_DATABASE}"
}
`;
    const dir = path.join(process.cwd(), 'api', 'src', 'models');
    const files = await fs.promises.readdir(dir);
    for (const file of files.filter(f => f.endsWith('.prisma'))) {
        schema += (fs.readFileSync(path.join(dir, file), 'utf-8') + "\n");
    }
    return schema;
}
